import { serverConfig } from 'config';
import { makeDynamicDataLoader } from './factory';

export const { get: getClientConfig, load: loadClientConfig } = makeDynamicDataLoader('config', set => {
  if (__SERVER__) {
    set(serverConfig.clientConfig);
  }
});
